import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import List from  '@material-ui/core/List';
import ListItem from  '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Header from './../Header';
import Footer from './../Footer';
import { Link, Redirect } from 'react-router-dom';
import { loadAppeals, logout } from "./../../actions/actions";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AppealsList from './../lists/AppealsList';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

const statuses = {
    DRAFT: 'Черновик',
    READY: 'Подготовлено',
    SIGNED: 'Отправлено',
    APPROVED: 'Принято',
    DECLINED: 'Отклонено'
}

const  states = {
    active:'активно',
    outdate:'просрочено'
}

const styles = {
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
};

export class InspectionAppeals extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            search:'',
            redirect: null,
            user: {},
            auth: false,
            appeals: []
        }
    }
    logout = () => {
        this.props.logout();
        this.setState({auth:false, user:{}, redirect:null});
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user !== null && 'role' in user && Array.isArray(user.role)) {
            if (user.role.indexOf('ROLE_INSPECTOR_MAIN')>-1 || user.role.indexOf('ROLE_SUPERVISOR')> -1) {
                this.setState({auth :true, user: user});
                this.props.loadAppeals(user.token);
            }
        }
    }

    componentWillReceiveProps(nextProps)
    {
        console.log('PROPS');
        if (!!Object.keys(nextProps.appeals).length) {
                this.setState({appeals: nextProps.appeals})
        }
    }
    render(){
        if ( this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        let {appeals} = this.props;
        
        let list = appeals.length > 0 ?

            <AppealsList items={appeals} title="Обращения" openLink="notification-card"/>:
            <p> Обращений нет</p>
        return (
        <div>

            {(this.state.user.role.indexOf('ROLE_INSPECTOR_MAIN')>=0 || this.state.user.role.indexOf('ROLE_INSPECTOR_APPEALS')>=0)&&(<Header link={{to:'/inspection/', title: this.state.user.org}} />)}
            {this.state.user.role.indexOf('ROLE_SUPERVISOR')>=0 && (<Header link={{to:'/supervision/', title: this.state.user.org}} />)}
            <Toolbar>
                {(this.state.user.role.indexOf('ROLE_SUPERVISOR')>=0) &&(<Button component={Link} to="/supervision">Вернуться</Button>)}
                {(this.state.user.role.indexOf('ROLE_INSPECTOR_MAIN')>=0 || this.state.user.role.indexOf('ROLE_INSPECTOR_APPEALS')>=0)&&(<Button component={Link} to="/inspection">Вернуться</Button> )}
                <Button onClick={this.logout}>Выйти</Button>
            </Toolbar>
        <Paper style={{padding:"2em"}}>
            {list}
        </Paper>
            <Footer />
        </div>
            );
    }
}

function select(state, props) {
    const { inspector } = state;
    console.log('SELECT');
    console.log(inspector);
    return {
        appeals: (typeof inspector !== "undefined" && 'appeals' in inspector) ?  inspector.appeals : []
    };
}

InspectionAppeals.defaultProps = {
    appeals: [],
    redirect: null
}


function mapDispatch(dispatch) {
    return {
        loadAppeals: bindActionCreators(loadAppeals, dispatch),
        logout:bindActionCreators(logout, dispatch)
    };
}


export default connect(select, mapDispatch)(InspectionAppeals);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/InspectionAppeals.jsx